import { render, staticRenderFns } from "./crearUnidadContenido.vue?vue&type=template&id=4f4f5e96"
import script from "./crearUnidadContenido.vue?vue&type=script&lang=js"
export * from "./crearUnidadContenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports